import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  title: {
    marginBottom: theme.spacing(1.5),
    letterSpacing: '-0.4px',
    [theme.breakpoints.down('lg')]: {
      fontSize: 18,
      marginBottom: theme.spacing(0.5),
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: 16,
      marginBottom: theme.spacing(1),
    },
  },
  radioGroup: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing(3),
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(1.5),
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        marginBottom: theme.spacing(3),
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        marginBottom: theme.spacing(1.5),
      }),
    },
  },
  radioLabel: {
    marginRight: 'auto',
    '& .MuiTypography-root': {
      fontSize: 18,
      [theme.breakpoints.down('md')]: {
        fontSize: 16,
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          fontSize: 16,
        }),
      },
    },
  },
  radioItem: {
    color: '#C6CAC6',
    padding: 8,
    '&$checked': { color: theme.palette.primary1 },
    [theme.breakpoints.down('md')]: {
      padding: 5,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        padding: 5,
      }),
    },
  },
  notice: {
    marginBottom: theme.spacing(4),
    color: theme.palette.red,
  },
}));
